import { render, staticRenderFns } from "./ModaMediaItem.vue?vue&type=template&id=60a0f58d"
import script from "./ModaMediaItem.vue?vue&type=script&lang=js"
export * from "./ModaMediaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports